/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { processNum } from '../../utils/num';
import { isEditable } from '../../utils/roles';
import { InputTransparent } from '../form/input.Transparent';

export const NumGauge = props => {
  const {
    num,
    numId,
    itemId,
    value,
    updateField,
    orientation = 'horizontal',
    canEdit = true,
  } = props;

  const [editValue, setEditValue] = useState(false);
  const [editLabel, setEditLabel] = useState(false);
  const isVertical = orientation === 'vertical';
  const canInteract = isEditable() && canEdit;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);

  const updateValue = value => {
    updateField(value, 'value');
    setEditValue(false);
  };

  const sanitize = str => {
    if (typeof str === 'string' && str.trim() === '') {
      return '-';
    }
    return str;
  };

  const updateLabel = value => {
    updateField(sanitize(value), 'label');
    setEditLabel(false);
  };

  const updateMod = mod => {
    updateField(+mod, 'mod');
    setEditValue(false);
  };

  const totalValue = processNum(
    { num, numId, useMod: false, useCon: true },
    item,
    items
  );
  const ratio =
    typeof totalValue === 'number' && totalValue !== 0
      ? Math.min(Math.max(value / totalValue, 0), 1)
      : 0;
  const progressPercent = ratio * 100;

  const updateModValue = delta => {
    updateMod(+num.mod + delta);
  };

  const renderValueContent = extraClass => {
    if (!editValue) {
      return (
        <div
          onClick={() => canInteract && setEditValue(true)}
          className={`${extraClass}`}
        >
          {value} / {totalValue}
        </div>
      );
    }
    return (
      <div
        className={`${
          isVertical ? 'flex flex-col items-center gap-02' : 'flex'
        } ${extraClass}`}
      >
        {canInteract ? (
          <InputTransparent
            className={`bg-transparent h-auto ${
              isVertical ? 'w-full text-center' : 'w-1/4 text-right'
            } border-0 px-0 py-0 m-0 flex-1 text-sm`}
            initValue={num.value + num.mod}
            onBlur={mod => updateMod(0 - num.value + +mod)}
          />
        ) : (
          <div className={`${isVertical ? 'w-full text-center' : 'w-1/4 text-right'} text-sm`}>
            {num.value + num.mod}
          </div>
        )}
        <span className={isVertical ? 'text-xs text-contrast' : ''}>/</span>
        {canInteract ? (
          <InputTransparent
            className={`bg-transparent h-auto ${
              isVertical ? 'w-full text-center' : 'w-1/4 text-left'
            } border-0 px-0 py-0 m-0 flex-1 text-sm`}
            initValue={num.value === 0 ? '0' : +num.value}
            onBlur={value => updateValue(value)}
          />
        ) : (
          <div className={`${isVertical ? 'w-full text-center' : 'w-1/4 text-left'} text-sm`}>
            {num.value === 0 ? '0' : +num.value}
          </div>
        )}
      </div>
    );
  };

  const renderLabel = () => (
    <div className='flex items-center gap-1'>
      {editLabel && canInteract ? (
        <div
          onClick={() => canInteract && setEditLabel(true)}
          className='uppercase text-condensed text-xs text-contrast text-opacity-50'
        >
          {num.label}
        </div>
      ) : (
        <div>
          {canInteract ? (
            <InputTransparent
              className='bg-transparent h-auto border-0 px-0 py-0 m-0 text-center uppercase text-condensed text-xs text-contrast text-opacity-50'
              initValue={num.label}
              onBlur={value => updateLabel(value)}
            />
          ) : (
            <div className='uppercase text-condensed text-xs text-contrast text-opacity-50'>
              {num.label}
            </div>
          )}
        </div>
      )}
    </div>
  );

  const renderHorizontalGauge = () => (
    <div className='relative flex flex-col items-center justify-center w-full h-full px-1'>
      <div className='flex w-full relative'>
        <div
          className={`${
            value < totalValue ? 'rounded-tl rounded-bl' : 'rounded'
          } bg-primary py-05 transition-all`}
          style={{
            transition: '300ms',
            width: `${progressPercent}%`,
          }}
        ></div>
        <div
          className={`${
            value < totalValue ? 'rounded-tr rounded-br' : 'rounded'
          } flex-1 bg-contrast bg-opacity-10 py-05 transition-all`}
        ></div>
        <div
          className={`absolute flex right-0 left-0 -top-03  ${
            !editValue ? 'parent-hover' : ''
          }`}
        >
          {canInteract && (
            <div
              className={`cursor-pointer show-on-hover mt-03 ml-05 ${
                editValue ? 'hidden' : ''
              }`}
              onClick={() => updateModValue(-1)}
              onContextMenu={e => {
                e.preventDefault();
                updateMod(-totalValue);
              }}
            >
              <FaMinus />
            </div>
          )}
          {renderValueContent('flex-1 text-center text-sm mt-03')}
          {canInteract && (
            <div
              className={`cursor-pointer show-on-hover mt-03 mr-05 ${
                editValue ? 'hidden' : ''
              }`}
              onClick={() => updateModValue(1)}
              onContextMenu={e => {
                e.preventDefault();
                updateMod(0);
              }}
            >
              <FaPlus />
            </div>
          )}
        </div>
      </div>
      {renderLabel()}
    </div>
  );

  const renderVerticalGauge = () => (
    <div className='relative flex flex-col items-center justify-center w-full h-full px-1'>
      <div className='flex flex-col items-center w-full h-full gap-05'>
        {canInteract && (
          <div
            className={`cursor-pointer ${editValue ? 'hidden' : ''}`}
            onClick={() => updateModValue(1)}
            onContextMenu={e => {
              e.preventDefault();
              updateMod(0);
            }}
          >
            <FaPlus />
          </div>
        )}
        <div className='flex-1 flex items-center justify-center w-full'>
          <div className='relative w-1 h-full rounded bg-contrast bg-opacity-10 overflow-hidden'>
            <div
              className={`absolute left-0 right-0 bg-primary ${
                value < totalValue ? '' : ''
              }`}
              style={{
                bottom: 0,
                height: `${progressPercent}%`,
                transition: '300ms',
              }}
            ></div>
          </div>
        </div>
        {renderValueContent(
          'text-center text-sm w-full flex items-center justify-center gap-02'
        )}
        {canInteract && (
          <div
            className={`cursor-pointer ${editValue ? 'hidden' : ''}`}
            onClick={() => updateModValue(-1)}
            onContextMenu={e => {
              e.preventDefault();
              updateMod(-totalValue);
            }}
          >
            <FaMinus />
          </div>
        )}
      </div>
      {renderLabel()}
    </div>
  );

  return isVertical ? renderVerticalGauge() : renderHorizontalGauge();
};
